import { render, staticRenderFns } from "./Learn-English-Lessons.vue?vue&type=template&id=15222aba&"
import script from "./Learn-English-Lessons.vue?vue&type=script&lang=js&"
export * from "./Learn-English-Lessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports